import CarouselSlide from './carousel-slide';
export default CarouselSlide;